import { ZoningStatus } from '@lidea/shared/util/types';

export const computeCornStatus = (values: Record<string, any>) => {
  const one_of_NBEP = [values['NBEP1'], values['NBEP2']].some(
    (val) => val !== null && val !== undefined
  );
  const NBEPl_only = values['NBEP1'] !== null && values['NBEP1'] !== undefined;
  const NBEP1_and_2 = [values['NBEP1'], values['NBEP2']].every(
    (val) => val !== null && val !== undefined
  );
  const one_of_NBG = [values['NBG11'], values['NBG21']].some(
    (val) => val !== null && val !== undefined
  );
  const all_of_NBG = [values['NBG11'], values['NBG21']].every(
    (val) => val !== null && val !== undefined
  );

  if ((NBEP1_and_2 || NBEPl_only) && (all_of_NBG || one_of_NBG)) {
    // if (values['NBG21'] == null) {
    //   values['NBG21'] = 0;
    // }
    // if (values['NBEP2'] == null) {
    //   values['NBEP2'] = 0;
    // }
    return ZoningStatus.Ready;
  } else if (one_of_NBEP || one_of_NBG) {
    return ZoningStatus.InProgress;
  } else {
    return ZoningStatus.ToBeDone;
  }
};
